import { render, staticRenderFns } from "./DataCard.vue?vue&type=template&id=6f56c6eb&"
import script from "./DataCard.vue?vue&type=script&lang=js&"
export * from "./DataCard.vue?vue&type=script&lang=js&"
import style0 from "./DataCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports